import { newYorkMidnight } from "@/utils/helper";

export const initialState = {
	title: '',
	thumnailLink: '',
	trailerThumnailLink: '',
	instructor: '',
	description: '',
	shortDescription: '',
	CategoryId: '',
	videoLevel: [],
	duration: '',
	trailerDuration: '',
	tags: [],
	keywords: [],
	products: [],
	isClass: false,
	muxVideoLink: '',
	muxTrailerLink: '',
	playbackId: '',
	releaseDate: null,
	muxStatus: 'preparing',
	muxUploadId: null,
	muxTrailerUploadId: null,
	dateOnly: newYorkMidnight(true)
};

export const formReducer = (state, action) => {
	switch (action.type) {
		case 'SET_FIELD':
			return { ...state, [action.field]: action.value };

		case 'SET_TAGS':
			return state.tags.includes(action.tag) ? state : { ...state, tags: [...state.tags, action.tag] };

		case 'REMOVE_TAG':
			return { ...state, tags: state.tags.filter(tag => tag !== action.tag) };

		case 'SET_PRODUCTS':
			return { ...state, products: [...state.products, action.product] };

		case 'REMOVE_PRODUCT':
			return {
				...state,
				products: state.products.filter(product => product !== action.product)
			};

		case 'SET_KEYWORDS':
			return { ...state, keywords: [...state.keywords, action.keyword] };

		case 'REMOVE_KEYWORD':
			return {
				...state,
				keywords: state.keywords.filter(keyword => keyword !== action.keyword)
			};

		case 'SET_VIDEO_LEVEL':
			return { ...state, videoLevel: action.levels };
		case 'SET_DATE':
			return {
				...state,
				releaseDate: action.date,
				dateOnly: action.date
			};
		case 'SET_IS_CLASS':
			return { ...state, isClass: action.value };

		case 'SET_VIDEO_DATA':
			return {
				...state,
				title: action.payload?.name,
				description: action.payload?.description,
				shortDescription: action.payload?.shortDescription,
				thumnailLink: action.payload?.pictures?.base_link,
				duration: action.payload?.duration,
				instructor: action.payload?.instructor,
				keywords: action.payload?.keywords || []
			};

		case 'SET_TRAILER_DATA':
			return {
				...state,
				trailerLink: action.payload?.player_embed_url,
				trailerThumnailLink: action.payload?.pictures?.base_link
			};

		case 'RESET_FORM':
			return initialState;

		default:
			return state;
	}
};

// Helper functions for dispatching actions
export const setField = (field, value) => ({ type: 'SET_FIELD', field, value });
export const addTag = tag => ({ type: 'SET_TAGS', tag });
export const removeTag = tag => ({ type: 'REMOVE_TAG', tag });
export const addProduct = product => ({ type: 'SET_PRODUCTS', product });
export const removeProduct = product => ({ type: 'REMOVE_PRODUCT', product });
export const addKeyword = keyword => ({ type: 'SET_KEYWORDS', keyword });
export const removeKeyword = keyword => ({ type: 'REMOVE_KEYWORD', keyword });
export const setVideoLevel = levels => ({ type: 'SET_VIDEO_LEVEL', levels });
export const setDate = date => ({ type: 'SET_DATE', date });
export const setVideoData = videoData => ({ type: 'SET_VIDEO_DATA', payload: videoData });
export const setIsClass = value => ({ type: 'SET_IS_CLASS', value });
export const setTrailerData = trailerData => ({ type: 'SET_TRAILER_DATA', payload: trailerData });
export const resetForm = () => ({ type: 'RESET_FORM' });
